import { createSlice } from "@reduxjs/toolkit";

interface OiTreeState {
    refreshTick: number;
}

const initialState: OiTreeState = { refreshTick: 0 };

const oiTreeSlice = createSlice({
    name: "oiTree",
    initialState,
    reducers: {
        // Asks the O&I side tree to re-fetch its order lists (e.g. after a status change that does not navigate).
        requestOiTreeRefresh: (state) => {
            state.refreshTick += 1;
        },
    },
});

export const { requestOiTreeRefresh } = oiTreeSlice.actions;
export default oiTreeSlice.reducer;
